import React, { useState } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import SeasonalComparatorToolbar from 'components/Meteorology/Weather/Comparator/Toolbar';
import ImageDisplay from 'components/Meteorology/Weather/Comparator/ImageDisplay';
import ComparatorControlPanel from 'components/Meteorology/Weather/ControlPanel/Comparator';
import { SeasonalComparatorImages } from 'types/Meteorology/Weather/SeasonalComparator/getImages';
import { ResponseError } from 'services/api/base';

import './index.scss';

export interface ComparatorMobileProps {
  images: SeasonalComparatorImages | undefined;
  queryError: ResponseError | undefined;
  onRetry: () => void;
  loading: boolean;
  onDownloadClick: () => void;
  downloadDisabled: boolean;
}

export default function ComparatorMobile({
  images,
  queryError,
  onRetry,
  loading,
  onDownloadClick,
  downloadDisabled,
}: ComparatorMobileProps) {
  const [panelOpen, setPanelOpen] = useState(false);

  return (
    <div className="weather-comparator-mobile">
      <QueryCard>
        <QueryCardHeader label="Comparador" title="Compare os modelos climáticos" />
        <QueryCardTrigger onClick={() => setPanelOpen(true)} />
      </QueryCard>

      <div className="weather-comparator-mobile-toolbar">
        <SeasonalComparatorToolbar
          downloadDisabled={downloadDisabled}
          onDownloadClick={onDownloadClick}
        />
      </div>

      {!loading && !queryError && !images && (
        <div className="weather-comparator-mobile-empty">
          <p className="weather-comparator-mobile-empty-title">Nenhuma comparação ainda</p>
          <p className="weather-comparator-mobile-empty-body">
            Escolha a variável, a área e os modelos no painel de controle e realize a consulta.
          </p>
        </div>
      )}

      <ImageDisplay
        images={images}
        queryError={queryError}
        onRetry={onRetry}
        loading={loading}
      />

      <BottomSheet open={panelOpen} dismiss={() => setPanelOpen(false)} title="Painel de controle">
        <ComparatorControlPanel />
      </BottomSheet>
    </div>
  );
}
